module.exports = __webpack_public_path__ + "static/media/empty.86bff310.svg";